import React, {Component} from 'react';
import styles from './styles/KingstonConnect.scss';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default class ManageProfilePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // _id: undefined,
      saving: false,
      old_password: undefined,
      new_password: undefined,
      new_password_confirm: undefined,
      error_message: undefined,
      saved: undefined,
    }
  }

  // componentDidMount() {
  //   this.setState({
  //     _id: this.props._id
  //   });
  // }

  updatePassword = (e) => {
    e.preventDefault();
    if (this.state.new_password !== this.state.new_password_confirm) {
      this.setState({
        error_message: "Please ensure that the new passwords match."
      })
    } else {
      // Check to see if password is correct
      axios
        .post("/api/kingstonconnect/checkemployerpassword/",
        {"_id": this.props._id, "password": this.state.old_password })
        .then(res => {
          // Flag as saving
          this.setState({
            error_message: undefined,
            saving: true
          })

          // Change Password
          axios
            .post("/api/kingstonconnect/changeemployerpassword/",
            {"_id": this.props._id,"password": this.state.new_password })
            .then(res => {
              this.setState({
                saved: true,
                saving: false
              })
            })
            .catch(e => {
              this.setState({
                error_message: "Something went wrong, please refresh the page and try again.",
                saved_recently: false,
                saving: false
              })
              console.log(e)
            });
        })
        .catch(e => {
          this.setState({
            error_message: "Old password does not match.",
            saved_recently: false,
            saving: false
          })
          console.log(e)
        });
    }
  }

  handleChange = (e) => {
    this.setState({
      error_message: undefined,
      saved: undefined,
      [e.target.id]: e.target.value
    })
  }


  render() {
    return (
      <div className={styles.page}>
        <h1> Change Password </h1>
        <form onSubmit={this.updatePassword}>
            <div className="form-group col-6 offset-3">

              <label>Old Password</label>
              <input required onChange={this.handleChange} id='old_password' type="password" className="form-control"/>

              <label>New Password</label>
              <input required onChange={this.handleChange} id='new_password' type="password" className="form-control"/>

              <label>Confirm New Password</label>
              <input required onChange={this.handleChange} id='new_password_confirm' type="password" className="form-control"/>

              <br/>

              {this.state.saved &&
                <div className="alert alert-success" role="alert">
                <strong>Saved!</strong> Your password has been changed.
                </div>
              }
              {this.state.error_message &&
                <div className="alert alert-danger" role="alert">
                <strong>Uh oh! </strong>{this.state.error_message}
                </div>
              }
            </div>
            <button className="btn btn-primary">
              {"Update Password "}
              {this.state.saving &&
                <FontAwesomeIcon spin
                icon={faSpinner}
                />
              }
            </button>
          </form>
          <br/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/ManageProfilePassword.js